import React, {Component} from 'react';
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import moment from "moment";
import Modal from 'react-modal';
import {db} from '../../firebase/index';

// This import loads the firebase namespace along with all its type information.
import firebase from 'firebase/app';
// These imports load individual services into the firestore namespace.
import 'firebase/firestore';

import {LATLON_QUERY, USER_SET} from "../../constants/ActionTypes";
import {minLength2, required} from "../../constants/ValidationRules";
import {
    AUTHOR_ID,
    CREATED, EVENT_DATE,
    GAME_TYPE,
    GAME_TYPE_CODE,
    PUBLIC,
    PUBLISHED,
    TITLE, TREASURE_TYPE, TREASURE_TYPE_TREASURE
} from "../../constants/Game";

import withAuthorization from '../auth/withAuthorization';
import CreateUserName from "./CreateUserName";
import { PublicPrivateChoice } from "../huntcomponents/PublicPrivateChoice";
import {EventHuntChoice, saturdayAtNoon} from "../huntcomponents/EventHuntChoice";
import { createGame, updateUserName } from "../../actions/index";
import { WizardHeader, renderField } from "../common_page_elements";
import {bindActionCreators} from "redux";

// css
import '../../global.css';
import './WizardStart.css';
import {parseLatLon, possessiveNameFromUser} from "../yourpage/HomePage";


// user name is invalid if it's less than two chars, trimmed.
const invalid = (nameString) => !nameString || nameString.trim().length < 2 || nameString.trim() === "Anonymous";

/**
 * Show the big form to enter a new game -- basic info.  (Game Clues to be entered on a different page).
 */
class WizardStart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            publicChecked: true,
            createUserNameModal: false,
            eventDateTime: null,
            gameType: GAME_TYPE_CODE,
            eventDate: null,
            // randomClueOrder: false,
            popDateChooser: false
        };

        // Use 'bind()' to make sure 'this' means this class instance inside these methods.
        this.openUserNameModal = this.openUserNameModal.bind(this);
        this.closeUserNameModal = this.closeUserNameModal.bind(this);
        this.onPublicPrivateChange = this.onPublicPrivateChange.bind(this);
        this.onGameTypeChange = this.onGameTypeChange.bind(this);
        this.onEventHuntChecked = this.onEventHuntChecked.bind(this);
        this.onEventHuntDateChange = this.onEventHuntDateChange.bind(this);
        // this.onRandomClueOrderChecked = this.onRandomClueOrderChecked.bind(this);
        this.onBackOut = this.onBackOut.bind(this);
    }

   componentDidMount () {
      window.scrollTo(0, 0)

      const latLon = parseLatLon(this.props.location.search);
      if (!!latLon) {
         this.props.setLatLon(latLon);
      }
   }

   UNSAFE_componentWillMount() {
        // if the user has no username, put up the modal dialog
        const { user } = this.props;
        if (!user) {
            this.fetchUser();
        } else {
            this.checkUsername(user);
        }
    }

    openUserNameModal() {
        if (! this.state.createUserNameModal) {
            this.setState({createUserNameModal: true});
        }
    }

    closeUserNameModal() {
        if (this.state.createUserNameModal) {
            this.setState({createUserNameModal: false});
        }
    }

    onPublicPrivateChange(event, newValue) {

        this.setState( { publicChecked: !this.state.publicChecked });
    }

    onGameTypeChange(event, newValue) {

        this.setState( { gameType: newValue });
    }

    onEventHuntChecked(event, newValue) {
        if (newValue) {
            this.setState( { eventDate: firebase.firestore.Timestamp.fromDate(saturdayAtNoon()) })
        } else {
            this.setState( { eventDate: null })
        }
    }

    onEventHuntDateChange(value) {
        if (!!value) {
            this.setState( { eventDate: firebase.firestore.Timestamp.fromDate(moment(value).toDate()) });
        } else {
            this.setState( { eventDate: null })
        }
    }

    // onRandomClueOrderChecked(event, value) {
    //     this.setState( { randomClueOrder: value })
    // }

    onSubmit(values) {
        const { user, createGame, history } = this.props;

        values[PUBLIC] = this.state.publicChecked;
        values[GAME_TYPE] = this.state.gameType;
        values[PUBLISHED] = false;
        // set date to now
        values[CREATED] = firebase.firestore.Timestamp.now();
        values[AUTHOR_ID] = user.id;
        if (!! this.state.eventDate) {
            values[EVENT_DATE] = this.state.eventDate;
            values[TREASURE_TYPE] = TREASURE_TYPE_TREASURE;
            // values[RANDOM_CLUES] = this.state.randomClueOrder && this.state.gameType === GAME_TYPE_CODE;
        }

        const isPublic = this.state.publicChecked;

        createGame(values, user.name, isPublic, (docRef) => {
            const id = docRef.id;
            history.push(`/games/${id}/new3`);
        });
    }

    onBackOut() {
        this.props.history.push(`/games`)
    }

    fetchUser() {
        const { authUser, onGetUser, updateUser } = this.props;

        db.getUser(authUser.uid).then(userDoc => {

            if (!userDoc) {
                console.warn("Could not find user in our firestore with authId = " + authUser.uid);
                alert("Problem with user Id in our database.")
            } else {
                onGetUser(userDoc);
                const user = userDoc.data();
                this.checkUsername(user);
            }
        }
        ).catch( error => {
            console.warn("No user in ourtreasurehunt firebase; this should be fixed with new mobile releases. Doing temp. fix: ");
            updateUser(authUser.uid, (!!authUser.displayName ? authUser.displayName : "Anonymous"), () => { })
        })
    }
    // export function updateUserName(userId, name, callback) {

    checkUsername(user) {
        // if the user has no username, put up the modal dialog
        const { name } = user;

        if (invalid(name)) {
            this.openUserNameModal();
        } else {
            this.closeUserNameModal();
        }
    }

    render() {
        const { handleSubmit } = this.props;

        const titleExplanation = "Let's start with the basics.  First, give your hunt a distinctive title.  "
            + "It can be short or long. ";

        return <div className='editor'>

            <WizardHeader
                backOutText="Exit to your hunt list"
                backOutAction={this.onBackOut}
                subtitle="Start creating your own treasure hunt!
                    On the next pages we'll add hunt location, clues and all the details.  You can edit your choices later.
                    If you haven't done so, you should play a hunt in the app first, such as 'Yellowstone Sample Hunt', to get an ideal how they work."
                index={0}
                stepName="Step 1:  Title and Type"
                stepExplanation={titleExplanation}
            />

            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                <Field
                    autoFocus={false}
                    name={TITLE}
                    id="title"
                    type="text"
                    isRow="true"
                    component={renderField}
                    explanation={titleExplanation}
                    label="Title"
                    placeholder="E.g. Treasure Hunt at Mulberry House"
                    validate={[required, minLength2]}
                />

                <div className="top-margine bottom-margin secondary-text"> Next, will your hunt be public or private?  </div>

                <PublicPrivateChoice
                    isPublic={this.state.publicChecked}
                    onChange={this.onPublicPrivateChange}
                />

                {/*<div className="bottom-margin secondary-text"> What game type is your hunt?  We recommend "Code to code", the most common and simplest type.</div>*/}

                {/*<GameTypeChoice*/}
                {/*    gameType={this.state.gameType}*/}
                {/*    onChange={this.onGameTypeChange}*/}
                {/*    randomClueOrder={this.state.randomClueOrder}*/}
                {/*    onRandomClueOrderChecked={this.onRandomClueOrderChecked}*/}
                {/*/>*/}

                <div className="top-margine bottom-margin secondary-text">
                    "Event" hunts are competitive hunts.  You can make an event out of any type of hunt, of course, but in this
                    type all players start at an exact time you specify and cannot skip clues or get hints whenever they like.
                    If this hunt is a competition or has a real prize at the end, consider making it an "Event Hunt".  </div>

                <EventHuntChoice
                    dateValue={this.state.eventDate}
                    onDateChange={this.onEventHuntDateChange}
                    onEventHuntChecked={this.onEventHuntChecked}
                    openDateChooser={this.state.popDateChooser}
                    // randomClueOrder={this.state.randomClueOrder}
                    // onRandomClueOrderChecked={this.onRandomClueOrderChecked}
                />

                <Link to="/games" className="btn btn-danger right-margin">Cancel</Link>
                <button type="submit" className="btn btn-primary left-margin">Next</button>

            </form>

            <Modal
                isOpen={this.state.createUserNameModal}
                onRequestClose={this.closeUserNameModal}
                className="my-modal-content"
                overlayClassName="NewGame-modal-overlay"
                shouldCloseOnOverlayClick={false}
            >
                <CreateUserName
                    closeModalCallback={this.closeUserNameModal}
                />
            </Modal>
        </div>;
    }
}

const authCondition = (authUser) => !!authUser;

function mapDispatchToProps(dispatch) {

   return bindActionCreators({
      onGetUser: (userDoc) => dispatch({type: USER_SET, payload: userDoc}),
      updateUser: updateUserName,
      setLatLon: (latLon) => dispatch({type: LATLON_QUERY, payload: latLon})
   }, dispatch)
}

const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser,
    user: state.userState.user,
});

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
WizardStart = reduxForm({
    form: 'NewGameForm' // a unique identifier for this form
})(
    connect(null, { createGame }
)(WizardStart));

// You have to connect() to any reducers that you wish to connect to yourself
WizardStart = connect(
   state => ({
      initialValues: {
         [AUTHOR_ID]: state.userState.user ? state.userState.user.name : "Unknown",
         [CREATED]: moment().format('MMM Do YYYY'),
         [TITLE]: possessiveNameFromUser(state.userState.user) + " Treasure Hunt"
      }
   })
)(WizardStart);

WizardStart = withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardStart));
WizardStart = withAuthorization(authCondition)(WizardStart);

export default WizardStart;



// WEBPACK FOOTER //
// ./src/components/huntwizard/WizardStart.js